import { DateField, EditButton, Labeled, Show, SimpleShowLayout, TextField, useShowController } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";

import { settings } from "app";
import ImagePreview from "./ImagePreview";

const ShowAlumniEvent = () => {
  const { record } = useShowController();

  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const galeryIds = record?.article?.imageIds;
  return (
    <Show
      title="Детайли на събитие"
      actions={
        <BackButtonToolbar
          additionalButton={
            <EditButton
              variant="contained"
              size="medium"
            />
          }
        />
      }
    >
      <SimpleShowLayout>
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <Typography color="primary">Данни за събитиетото</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Заглавие">
              <TextField source="title" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Подзаглавие">
              <TextField source="subtitle" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
          >
            <Labeled label="Съдържание">
              <TextField source="content" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Локация">
              <TextField source="location" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Стартова дата">
              <DateField
                source="startsAt"
                showTime
                locales="bg-BG"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
          >
            <Typography
              color="primary"
              sx={{ fontSize: "12px" }}
              fontWeight={"bold"}
              mb={2}
            >
              Водеща снимка
            </Typography>
            <ImagePreview id={record?.imageId} />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <Typography color="primary">Данни за статия</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Заглавие на статия">
              <TextField source="article.title" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Подзаглавие на статия">
              <TextField source="article.subtitle" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
          >
            <Labeled label="Съдържание на статия">
              <TextField source="article.content" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
          >
            <Typography
              color="primary"
              sx={{ fontSize: "12px" }}
              fontWeight={"bold"}
              mb={2}
            >
              Водеща снимка
            </Typography>
            <ImagePreview id={record?.article?.imageId} />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <Typography
              color="primary"
              sx={{ fontSize: "12px" }}
              fontWeight={"bold"}
              mb={2}
            >
              Галерия снимки
            </Typography>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
              {galeryIds?.length > 0 ? (
                galeryIds.map((image, idx) => {
                  return <ImagePreview id={image} />;
                })
              ) : (
                <p>Няма качени снимки</p>
              )}
            </Box>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowAlumniEvent;
